import { render, staticRenderFns } from "./FortuneWheelModel.vue?vue&type=template&id=6f260d3b"
import script from "./FortuneWheelModel.vue?vue&type=script&lang=js"
export * from "./FortuneWheelModel.vue?vue&type=script&lang=js"
import style0 from "./FortuneWheelModel.vue?vue&type=style&index=0&id=6f260d3b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports